// src/Menu.js
import React from 'react';

const Menu = () => (
  <nav className="menu">
    <ul>
      <li><a href="/">Thumbnail Wizard</a></li>
      {/* <li><a href="/Wisdoms.html">Wizard Wisdoms</a></li> */}
    </ul>
  </nav>
);

export default Menu;